module.exports = __webpack_public_path__ + "img/3.521d81c1.svg";